import uniq from 'lodash/uniq';

const zipObjects = (objA, objB) => {
  const keys = uniq([
    ...Object.keys(objA),
    ...Object.keys(objB),
  ]);
  return keys.reduce((zippedObj, key) => {
    zippedObj[key] = [objA[key], objB[key]];
    return zippedObj;
  }, {});
};

export default zipObjects;
